import { prependYear } from 'linced-app/helpers/prepend-year';
import { isEmpty } from '@ember/utils';

// matchYearLevel is used as a custom matcher in components handling the selection
// of year levels for all school jurisdictions
export function matchYearLevel(option, term) {
  // Need to cover for cases of year levels such as:
  // - Numeric (0 or '0')
  // - Letters only ('K')
  // - Alphanumeric ('K1', 'Year 0', etc.)

  // Remove non-digit characters to handle the numeric part
  let numericText = term.replace(/[^\d]+/g, '');
  // Sometimes, we display year levels with the word 'year' prepended without
  // actually feeding it into the options, so when users type in "year ...",
  // it would not return anything.
  // The function decides whether to prepend the word "year" to it or not
  let prependedYearOption = prependYear([option]);

  if (
    (!isEmpty(numericText) && option.toLowerCase().includes(numericText)) ||
    prependedYearOption.toLowerCase().includes(term.toLowerCase())
  ) {
    // We have a match
    return 1;
  }
  return -1;
}
